import type { Params } from '@vimcar/mvvm/linkViewModel'
import type { CustomNode } from '#models/Nodes/CustomNode'

import * as mobx from 'mobx'
import PT from 'prop-types'

import type { NodeLink } from '../../models/Nodes/NodeLink'
import type { ViewState } from '../Root/viewModel'
import type { Transitioner } from '../TransitionProvider'

export type Props = {
  state: ViewState
  node: CustomNode
}

export type ViewModel = {
  node: CustomNode
  options: Array<NodeLink>
  showButtons: boolean
  showContinue: boolean
  _searchTerm: string
  handleLinkClick: (NodeLink) => () => void
  handleNext: () => void
  handleSearchFormChange: (arg: { term: string }) => void
}

type Context = {
  transitioner: Transitioner
}

const mkViewModel = (
  _params: Params,
  props: Props,
  { transitioner }: Context,
): ViewModel => {
  const vm = mobx.observable({
    _searchTerm: '',
    get node() {
      if (props.node) return props.node
      return props.state.currentNode
    },
    get options() {
      // @ts-expect-error@2339
      const filterTerm = props.filterTerm || vm._searchTerm
      if (filterTerm) {
        const linkGroupLinks = vm.node.linkGroup ? vm.node.linkGroup.links : []
        const noDup = new Map()
        vm.node.options.concat(linkGroupLinks).forEach((link) => {
          noDup.set(link.id, link)
        })

        return Array.from(noDup.values()).filter((option) =>
          option.matches(filterTerm),
        )
      } else if (vm.node && vm.node.options && vm.node.options.length) {
        return vm.node.options.filter((option) => option.matches(filterTerm))
      }
      return []
    },
    get showButtons() {
      return !props.node && (vm.node.allowBack || vm.node.nextNode)
    },
    get showContinue() {
      return !!vm.node.nextNode
    },
    handleLinkClick: (option) => () => {
      transitioner.openExternal(option.externalLink)
    },
    handleNext: mobx.action(() => {
      const nextNode = vm.node.nextNode
      if (!nextNode) throw new Error('no node linked as next')
      transitioner.goForward(nextNode.id)
    }),
    handleSearchFormChange: mobx.action((term) => {
      // @ts-expect-error@2339
      vm._searchTerm = term && term.length >= 3 ? term : ''
    }),
  })

  return vm
}

mkViewModel.contextTypes = {
  transitioner: PT.object.isRequired,
}

export default mkViewModel
